import styled from 'styled-components';

// CONSTANTS
import { breakpoints } from '@/utility/breakpoints';

export const Wrapper = styled.div`
  padding-bottom: 150px;

  ${breakpoints.down('xs')} {
    padding-bottom: 45px;
  }

  > div {
    width: 100%;
  }

  .similar-content-section {
    padding-bottom: 45px;

    ${breakpoints.up('md')} {
      padding-bottom: 65px;
    }
  }
`;

export const ProgressWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  position: relative;
  z-index: 1102;
`;

export const Container = styled.div`
  position: relative;
  padding-top: 110px;
  padding-bottom: 50px;

  ${breakpoints.down('md')} {
    padding-top: 85px;

    h3 {
      font-size: 3rem;
      line-height: 3rem;
    }
  }

  ${breakpoints.down('xs')} {
    padding-top: 60px;
  }
`;

export default Wrapper;
